import { DoctorTypeConstants } from '../types/DoctorTypeConstants';

export const DoctorAction = {
    register,
    registrationFailiure,
    registrationSuccess,
    updateProfile,
    updateProfileSuccess,
    updateProfileFailiure,
    getAllDoctors,
    getAllDoctorSuccess,
    getAllDoctorFailiure,
    getDoctorById,
    getDoctorByIdSuccess,
    getDoctorByIdFailiure,
    searchDoctor,
    searchDoctorSuccess,
    searchDoctorFailiure,
    searchDoctorBySpecialization,
    searchDoctorBySpecializationSuccess,
    searchDoctorBySpecializationFailiure,
    searchDoctorAppointment,
    searchDoctorAppointmentSuccess,
    searchDoctorAppointmentFailiure,
    clearDoctorSearchResult
};

function register(data) {
    return { type: DoctorTypeConstants.REGISTER_DOCTOR_REQUEST, data };
}

function registrationFailiure(message) {
    return { type: DoctorTypeConstants.REGISTER_DOCTOR_FAILURE, message:message };
}

function registrationSuccess(user) {
    return { type: DoctorTypeConstants.REGISTER_DOCTOR_SUCCESS, user };
}

function updateProfile(data) {
    return { type: DoctorTypeConstants.UPDATE_DOCTOR_REQUEST, data };
}

function updateProfileSuccess(user) {
    return { type: DoctorTypeConstants.UPDATE_DOCTOR_SUCCESS, user };
}

function updateProfileFailiure(message) {
    return { type: DoctorTypeConstants.UPDATE_DOCTOR_FAILURE, message };
}

function getAllDoctors() {
    return { type: DoctorTypeConstants.GET_ALL_DOCTOR_REQUEST };
}

function getAllDoctorSuccess(data) {
    return { type: DoctorTypeConstants.GET_ALL_DOCTOR_SUCCESS,data };
}

function getAllDoctorFailiure(message) {
    return { type: DoctorTypeConstants.GET_ALL_DOCTOR_FAILIURE , message:message };
}

function getDoctorById(id){
    return { type: DoctorTypeConstants.GET_DOCTOR_BY_ID_REQUEST,id };
}
function getDoctorByIdSuccess(data){
    return { type: DoctorTypeConstants.GET_DOCTOR_BY_ID_SUCCESS,data };
}
function getDoctorByIdFailiure(message){
    return { type: DoctorTypeConstants.GET_DOCTOR_BY_ID_FAILIURE, message:message };
}


function searchDoctor(data){
    return { type: DoctorTypeConstants.SEARCH_DOCTOR_REQUEST,data };
}
function searchDoctorSuccess(data){
    return { type: DoctorTypeConstants.SEARCH_DOCTOR_SUCCESS,data };
}
function searchDoctorFailiure(message){
    return { type: DoctorTypeConstants.SEARCH_DOCTOR_FAILIURE, message:message };
}

function searchDoctorBySpecialization(data){
    return { type: DoctorTypeConstants.SEARCH_DOCTOR_BY_SPECIALIZATION_REQUEST,data};
}
function searchDoctorBySpecializationSuccess(data){
    return { type: DoctorTypeConstants.SEARCH_DOCTOR_BY_SPECIALIZATION_SUCCESS,data };
}
function searchDoctorBySpecializationFailiure(message){
    return { type: DoctorTypeConstants.SEARCH_DOCTOR_BY_SPECIALIZATION_FAILIURE, message:message };
}

function searchDoctorAppointment(data){
    return { type: DoctorTypeConstants.DOCTOR_APPOINTMENT_REQUEST,data };
}
function searchDoctorAppointmentSuccess(data){
    return { type: DoctorTypeConstants.DOCTOR_APPOINTMENT_SUCCESS,data };
}
function searchDoctorAppointmentFailiure(message){
    return { type: DoctorTypeConstants.DOCTOR_APPOINTMENT_FAILIURE, message:message };
}
function clearDoctorSearchResult(){
    return { type: DoctorTypeConstants.CLEAR_DOCTOR_SEARCH_RESULT };
}
